import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getData, imgUrl } from '../Services/api'
import Pagination from '../Services/Pagination'
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom";

// Backend already returns formatted time (e.g. "3:00 PM"), display directly
const formatTime = (timeStr) => {
  if (!timeStr) return '-';
  return timeStr;
};

const List = () => {
  const [limit, setLimit] = useState(10);
  const [plans, setPlans] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');




  const location = useLocation();
const params = new URLSearchParams(location.search);

const manager = params.get("manager");

const from = params.get("from");
const to = params.get("to");
const type = params.get("type");

const [filters, setFilters] = useState({
  managerId: manager || '',
  type: type || '',
  dateFrom: from || '',
  dateTo: to || ''
});

const downloadBeatPlanExcel = async () => {
  try {
    const res = await axios.get(`${imgUrl}/api/v1/beatPlan/export`, {
      params: filters,
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, 'beatplan.xlsx');

  } catch (err) {
    console.error('Error downloading BeatPlan Excel:', err);
  }
};



  const fetchPlans = async (pageNumber = page, searchQuery = search) => {
    try {
      // const res = await getData(`/beatPlan/all-plan-list?page=${pageNumber}&search=${searchQuery}`);
      const query = new URLSearchParams({
  page: pageNumber,
  search: searchQuery,
  ...filters
}).toString();

const res = await getData(`/beatPlan/all-plan-list?${query}`);
      if (res.success) {
        setPlans(res.data || []);
        setPage(res.pagination?.page || 1);
        setPages(res.pagination?.pages || 0);
        setTotal(res.pagination?.total || 1);
        setLimit(res.pagination?.limit || 10);
      }
    } catch (error) {
      console.log("error fetching beat plan list", error)
    }
  }

useEffect(() => {
  // wait until filter initialized
  // if (manager !== null) {
    fetchPlans();
  // }  
}, [page, search, filters, manager]);
 

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      fetchPlans(pageNumber);
    }
  };


useEffect(() => {
  if (manager || from || to || type) {
    setFilters(prev => ({
      ...prev,
      managerId: manager || '',
      type: type || '',
      dateFrom: from || '',
      dateTo: to || ''
    }));
    setPage(1);
  }
}, [manager, from, to, type]);





  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Beat Plan
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <div className="page-header-title">
                  <h2 className="mb-0">Beat Plan List</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card table-card">
              <div className="card-body">
                <div className="d-sm-flex align-items-center p-4">
                  <ul className="list-inline me-auto my-1">
                    <li className="list-inline-item">
                      <div className="form-search">
                        <i className="fas fa-search" />
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search Beat Plan"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                          }}
                        />
                      </div>
                    </li>
                      
                  </ul>
                  <div>
                  <button className="btn btn-success mb-3"  onClick={downloadBeatPlanExcel}>
                        Export BeatPlan
                      </button>
                </div>
                </div>
                

                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Customer</th>
                        <th>Route</th>
                        <th>User</th>
                        <th>Status</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {plans?.length > 0 ? (
                        plans.map((plan, index) => (
                          <tr key={plan.id}>
                            <td>{index + 1 + (page - 1) * limit}</td>
                            <td>{plan.date}</td>
                            <td>{formatTime(plan.startTime)} - {formatTime(plan.endTime)}</td>
                            <td>{plan.Customer?.name || "-"}</td>
                            <td>{plan.Route?.route_name || "-"}</td>
                            <td>{plan.User?.username || "-"}</td>
                            <td>{plan.status}</td>
                            <td className="text-center">
                              <ul className="list-inline me-auto mb-0">
                                <li
                                  className="list-inline-item align-bottom"
                                  data-bs-toggle="tooltip"
                                  title="View"
                                >
                                  <Link
                                    to={`/beat/view/${plan.id}`}
                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                  >
                                    <i className="fas fa-eye f-18" />
                                  </Link>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan={8}>
                            <strong>No Beat Plans Found.</strong>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                  <div className="text-muted">
                    Showing {(page - 1) * limit + 1} to {Math.min(page * limit, total)} of {total} entries
                  </div>
                  <Pagination
                    page={page}
                    pages={pages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  )
}

export default List